import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledActionButton = styled(Link)`
  margin-right: 1rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  text-transform: uppercase;
  background: #829196;
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    width: ${(props) => props.$expandWidth || '8rem'};
    border-radius: 5px;
    color: #fff;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    background: var(--second-color);
    overflow: hidden;
    white-space: nowrap;
    justify-content: flex-start;
  }

  & > i {
    flex-shrink: 0;
    min-width: 1rem;
  }

  &::after {
    content: attr(data-label);
    display: none;
    margin-left: 0.5rem;
    font-size: 0.85rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover::after {
    display: inline-block;
  }
`;

const StyledActionButtonInMenu = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  padding: 0.75rem 1.5rem;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  transition: background-color 0.2s ease, color 0.2s ease;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  font-size: 0.95rem;
  font-weight: 400;
  outline: none;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
  }

  &:focus {
    outline: none;
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
  }

  & > i {
    font-size: 1.1rem;
    width: 1.5rem;
    text-align: center;
  }

  @media (max-width: 900px) {
    font-size: 1.05rem;
    padding: 0.875rem 1.5rem;

    & > i {
      font-size: 1.2rem;
    }
  }
`;

const ActionButton = ({
  to,
  icon,
  label,
  expandWidth,
  inMenu = false,
  ...props
}) => {
  if (inMenu) {
    return (
      <StyledActionButtonInMenu to={to} {...props}>
        <i className={icon}></i>
        <span>{label}</span>
      </StyledActionButtonInMenu>
    );
  }

  return (
    <StyledActionButton
      to={to}
      data-label={label}
      $expandWidth={expandWidth}
      {...props}>
      <i className={icon}></i>
    </StyledActionButton>
  );
};

export default ActionButton;
